export default __webpack_public_path__ + "static/media/logo-viajar-faz-bem.4e1ebccf.svg";